import styled, { css } from 'styled-components';
import { T as Text } from '../../Text/Text-Ce2yOjWM.js';
import { D as Divider } from '../../Divider/Divider-CeKwSczh.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const DropdownDivider = /*#__PURE__*/styled(Divider).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1g82k13-0"
})(["margin:0;"]);
DropdownDivider.displayName = 'DropdownDivider';
const StyledSelectOptionGroupHeader = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1g82k13-1"
})(["user-select:none;font-weight:", ";padding-block:", ";padding-inline:", ";", ""], ({
  theme
}) => theme.font.weight.bold, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.controls.paddingInline.base.default, isMobile(css(["padding-block:", ";padding-inline:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile, ({
  theme
}) => theme.controls.paddingInline.base.mobile)));
StyledSelectOptionGroupHeader.displayName = 'StyledSelectOptionGroupHeader';
const SelectOptionGroupContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1g82k13-2"
})([":first-child > ", "{display:none;};text-align:start;"], DropdownDivider);

export { DropdownDivider as D, SelectOptionGroupContainer as S, StyledSelectOptionGroupHeader as a };
//# sourceMappingURL=SelectOptionGroup.styles-lQBZhu_Y.js.map
